import { RouteObject } from "react-router";
import Home from "@/routes/home/Home";
import { ROUTES } from "@/constants/routes";

export const homeRoutes: RouteObject[] = [
  {
    index: true,
    id: ROUTES.homeWelcome.id,
    element: <Home />,
  },
];
